<template>
  <div class="ui right aligned container">
    <button @click="refresh" class="ui primary icon button"><i class="sync icon"></i></button>

    <vuetable ref="vuetable"
              api-url="/users"
              :fields="fields"
              @vuetable:pagination-data="onPaginationData"
    >
      <template scope="props" slot="actions">
        <i @click="edit(props.rowData)" class="edit link icon"></i>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>

    <Modal v-model="modal">
      <template slot="title">
        更新用户
      </template>
      <form class="ui form">
        <div class="field">
          <label>用户名</label>
          <input name="username" type="text" v-model="user.username" readonly>
        </div>
        <div class="field">
          <label>邮箱</label>
          <input name="email" type="email" min="0" v-model="user.email">
        </div>
        <RadioBox inline v-model="user.role" :options="options">角色</RadioBox>
        <div class="field">
          <div class="ui toggle delegate checkbox">
            <input type="checkbox" v-model="user.enabled">
            <label>有效</label>
          </div>
        </div>
      </form>
      <template slot="actions">
        <div @click="modal=false" class="ui cancel button">取消</div>
        <div @click="onSubmit" class="ui positive button">更新</div>
      </template>
    </Modal>

  </div>
</template>

<script>
import Vuetable from '../../table/Vuetable.vue'
import VuetablePagination from '../../table/VuetablePagination.vue'
import Modal from '../../components/Modal'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import RadioBox from '@/components/RadioBox'

export default {
  name: 'UserAdmin',
  components: {
    Vuetable,
    VuetablePagination,
    DatePicker,
    Modal,
    RadioBox,
  },
  data () {
    return {
      modal: false,
      user: {},
      options: [
        { key: "ROLE_ADMIN", value: "ROLE_ADMIN", text: "管理员" },
        { key: "ROLE_STAFF", value: "ROLE_STAFF", text: "员工" },
        { key: "ROLE_USER", value: "ROLE_USER", text: "用户" },
      ],
      fields: [
        { name: 'id', title: 'ID' },
        { name: 'username', title: '用户名' },
        { name: 'role', title: '角色' },
        { name: 'email', title: '邮箱' },
        { name: 'enabled', title: '有效' },
        { name: 'createdTime', title: '注册时间', callback: 'date' },
        { name: '__slot:actions', title: '操作' }
      ],
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    refresh: function () {
      this.$refs.vuetable.reload()
    },
    date: function (value) {
      return value ? new Date(value).toLocaleString() : ''
    },

    edit (item) {
      this.user = item
      this.modal = true
    },
    onSubmit () {
      axios.put('/admin/users/' + this.user.id, this.user).then(() => {
        this.modal = false
        this.refresh()
      }).catch((error) => {
        this.$toasted.error(error.message)
      })
    },
  }
}
</script>

<style scoped>

</style>
